var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 18.0844V19.5084C10.0631 21.1318 7.87961 22.3565 5.03156 22.3565C2.18351 22.3565 0 21.1318 0 19.5084V18.0844H10.0631Z",
    fill: "#FEA832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 18.0844V19.5084C10.0633 21.1318 7.87979 22.3565 5.03174 22.3565V18.0844H10.0633Z",
    fill: "#FE9923"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 16.6604V18.0844C10.0631 19.7078 7.87961 20.9324 5.03156 20.9324C2.18351 20.9324 0 19.7078 0 18.0844V16.6604H10.0631Z",
    fill: "#FEA832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 16.6604V18.0844C10.0633 19.7078 7.87979 20.9324 5.03174 20.9324V16.6604H10.0633Z",
    fill: "#FE9923"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 16.6604V18.0844C10.0631 19.7078 7.87961 20.9324 5.03156 20.9324C2.18351 20.9324 0 19.7078 0 18.0844V16.6604H10.0631Z",
    fill: "#FEDB41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 16.6604V18.0844C10.0633 19.7078 7.87979 20.9324 5.03174 20.9324V16.6604H10.0633Z",
    fill: "#FFCC33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 15.2364V16.6604C10.0631 18.2838 7.87961 19.5084 5.03156 19.5084C2.18351 19.5084 0 18.2838 0 16.6604V15.2364H10.0631Z",
    fill: "#FEA832"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 15.2364V16.6604C10.0633 18.2838 7.87979 19.5084 5.03174 19.5084V15.2364H10.0633Z",
    fill: "#FE9923"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 13.8123V15.2363C10.0631 16.8597 7.87961 18.0844 5.03156 18.0844C2.18351 18.0844 0 16.8597 0 15.2363V13.8123H10.0631Z",
    fill: "#FEDB41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 13.8123V15.2363C10.0633 16.8597 7.87979 18.0844 5.03174 18.0844V13.8123H10.0633Z",
    fill: "#FFCC33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 12.3883V13.8123C10.0631 15.4357 7.87961 16.6604 5.03156 16.6604C2.18351 16.6604 0 15.4357 0 13.8123V12.3883H10.0631Z",
    fill: "#FEA832"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 12.3883V13.8123C10.0633 15.4357 7.87979 16.6604 5.03174 16.6604V12.3883H10.0633Z",
    fill: "#FE9923"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 10.9643V12.3883C10.0631 14.0117 7.87961 15.2363 5.03156 15.2363C2.18351 15.2363 0 14.0117 0 12.3883V10.9643H10.0631Z",
    fill: "#FEDB41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 10.9643V12.3883C10.0633 14.0117 7.87979 15.2363 5.03174 15.2363V10.9643H10.0633Z",
    fill: "#FFCC33"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 9.54025V10.9643C10.0631 12.5877 7.87961 13.8123 5.03156 13.8123C2.18351 13.8123 0 12.5877 0 10.9643V9.54025H10.0631Z",
    fill: "#FEA832"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 9.54025V10.9643C10.0633 12.5877 7.87979 13.8123 5.03174 13.8123V9.54025H10.0633Z",
    fill: "#FE9923"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 8.11621V9.54024C10.0631 11.1636 7.87961 12.3883 5.03156 12.3883C2.18351 12.3883 0 11.1636 0 9.54024V8.11621H10.0631Z",
    fill: "#FEDB41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 8.11621V9.54024C10.0633 11.1636 7.87979 12.3883 5.03174 12.3883V8.11621H10.0633Z",
    fill: "#FFCC33"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 6.6922V8.11622C10.0631 9.73961 7.87961 10.9643 5.03156 10.9643C2.18351 10.9643 0 9.73961 0 8.11622V6.6922H10.0631Z",
    fill: "#FEA832"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 6.6922V8.11622C10.0633 9.73961 7.87979 10.9643 5.03174 10.9643V6.6922H10.0633Z",
    fill: "#FE9923"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 5.26816V6.69218C10.0631 8.31557 7.87961 9.54023 5.03156 9.54023C2.18351 9.54023 0 8.31557 0 6.69218V5.26816H10.0631Z",
    fill: "#FEDB41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 5.26816V6.69218C10.0633 8.31557 7.87979 9.54023 5.03174 9.54023V5.26816H10.0633Z",
    fill: "#FFCC33"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0631 3.84415V5.26817C10.0631 6.89156 7.87961 8.11622 5.03156 8.11622C2.18351 8.11622 0 6.89156 0 5.26817V3.84415H10.0631Z",
    fill: "#FEA832"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 3.84415V5.26817C10.0633 6.89156 7.87979 8.11622 5.03174 8.11622V3.84415H10.0633Z",
    fill: "#FE9923"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03156 0.996094C2.18351 0.996094 0 2.22076 0 3.84414C0 5.46753 2.18351 6.69219 5.03156 6.69219C7.87961 6.69219 10.0631 5.46753 10.0631 3.84414C10.0631 2.22076 7.87961 0.996094 5.03156 0.996094Z",
    fill: "#FEDB41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0633 3.84414C10.0633 5.46753 7.87979 6.69219 5.03174 6.69219V0.996094C7.87979 0.996094 10.0633 2.22076 10.0633 3.84414Z",
    fill: "#FFCC33"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 18.0844V19.5084C20.0312 21.1318 17.8951 22.3565 15.0471 22.3565C12.199 22.3565 10.063 21.1318 10.063 19.5084V18.0844H20.0312Z",
    fill: "#FEA832"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 18.0844V19.5084C20.0315 21.1318 17.8954 22.3565 15.0474 22.3565V18.0844H20.0315Z",
    fill: "#FE9923"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 16.6604V18.0844C20.0312 19.7078 17.8951 20.9324 15.0471 20.9324C12.199 20.9324 10.063 19.7078 10.063 18.0844V16.6604H20.0312Z",
    fill: "#FEDB41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 16.6604V18.0844C20.0315 19.7078 17.8954 20.9324 15.0474 20.9324V16.6604H20.0315Z",
    fill: "#FFCC33"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 15.2364V16.6604C20.0312 18.2838 17.8951 19.5084 15.0471 19.5084C12.199 19.5084 10.063 18.2838 10.063 16.6604V15.2364H20.0312Z",
    fill: "#FEA832"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 15.2364V16.6604C20.0315 18.2838 17.8954 19.5084 15.0474 19.5084V15.2364H20.0315Z",
    fill: "#FE9923"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 13.8123V15.2363C20.0312 16.8597 17.8951 18.0844 15.0471 18.0844C12.199 18.0844 10.063 16.8597 10.063 15.2363V13.8123H20.0312Z",
    fill: "#FEDB41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 13.8123V15.2363C20.0315 16.8597 17.8954 18.0844 15.0474 18.0844V13.8123H20.0315Z",
    fill: "#FFCC33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 12.3883V13.8123C20.0312 15.4357 17.8951 16.6604 15.0471 16.6604C12.199 16.6604 10.063 15.4357 10.063 13.8123V12.3883H20.0312Z",
    fill: "#FEA832"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 12.3883V13.8123C20.0315 15.4357 17.8954 16.6604 15.0474 16.6604V12.3883H20.0315Z",
    fill: "#FE9923"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 10.9643V12.3883C20.0312 14.0117 17.8951 15.2363 15.0471 15.2363C12.199 15.2363 10.063 14.0117 10.063 12.3883V10.9643H20.0312Z",
    fill: "#FEDB41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 10.9643V12.3883C20.0315 14.0117 17.8954 15.2363 15.0474 15.2363V10.9643H20.0315Z",
    fill: "#FFCC33"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 9.54025V10.9643C20.0312 12.5877 17.8951 13.8123 15.0471 13.8123C12.199 13.8123 10.063 12.5877 10.063 10.9643V9.54025H20.0312Z",
    fill: "#FEA832"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 9.54025V10.9643C20.0315 12.5877 17.8954 13.8123 15.0474 13.8123V9.54025H20.0315Z",
    fill: "#FE9923"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 8.11621V9.54024C20.0312 11.1636 17.8951 12.3883 15.0471 12.3883C12.199 12.3883 10.063 11.1636 10.063 9.54024V8.11621H20.0312Z",
    fill: "#FEDB41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 8.11621V9.54024C20.0315 11.1636 17.8954 12.3883 15.0474 12.3883V8.11621H20.0315Z",
    fill: "#FFCC33"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 6.6922V8.11622C20.0312 9.73961 17.8951 10.9643 15.0471 10.9643C12.199 10.9643 10.063 9.73961 10.063 8.11622V6.6922H20.0312Z",
    fill: "#FEA832"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 6.6922V8.11622C20.0315 9.73961 17.8954 10.9643 15.0474 10.9643V6.6922H20.0315Z",
    fill: "#FE9923"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 3.84415C12.199 3.84415 10.063 5.06881 10.063 6.6922C10.063 8.31559 12.199 9.54025 15.0471 9.54025C17.8951 9.54025 20.0312 8.31559 20.0312 6.6922C20.0312 5.06881 17.8951 3.84415 15.0471 3.84415Z",
    fill: "#FEDB41"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 6.6922C20.0315 8.31559 17.8954 9.54025 15.0474 9.54025V3.84415C17.8954 3.84415 20.0315 5.06881 20.0315 6.6922Z",
    fill: "#FFCC33"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6072 12.1747C15.4601 12.1747 12.9111 14.7237 12.9111 17.8708C12.9111 21.0179 15.4601 23.5669 18.6072 23.5669C21.7544 23.5669 24.3033 21.0179 24.3033 17.8708C24.3033 14.7237 21.7544 12.1747 18.6072 12.1747Z",
    fill: "#FEA832"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3035 17.8708C24.3035 21.0179 21.7546 23.5669 18.6074 23.5669V12.1747C21.7546 12.1747 24.3035 14.7237 24.3035 17.8708Z",
    fill: "#FE9923"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.607 13.5987C16.2573 13.5987 14.335 15.5212 14.335 17.8708C14.335 20.2205 16.2573 22.1429 18.607 22.1429C20.9567 22.1429 22.8791 20.2205 22.8791 17.8708C22.8791 15.5212 20.9567 13.5987 18.607 13.5987Z",
    fill: "#FEDB41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8795 17.8708C22.8795 20.2205 20.9571 22.1429 18.6074 22.1429V13.5987C20.9571 13.5987 22.8795 15.5212 22.8795 17.8708Z",
    fill: "#FFCC33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.8a550d556b3809b02dd0a3bbaed26392.svg";
export { ForwardRef as ReactComponent };